import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const TabPanelStyled = styled(Box, {
  '&:focus': {
    outline: '$borderWidths$2 solid $colors$primary',
    borderRadius: '$2',
  },
});
